export default __webpack_public_path__ + "static/use-1-en-50848e1c6bfa938d72cd972d36051482.png";